import BaseStep from "../../../../../../../shared/wizard/steps/baseStep";
import { useWizard } from "react-use-wizard";
import sellSteps from "../../sellSteps";
import { IFillDataWizardSell } from "../../..";
import Button from "../../../../../../../ui/button";
import useDealRequest from "../../../../../../../../api/hooks/use-deal-request";
import { getAccessToken } from "../../../../../../../../lib/services/localStorage.service";
import { toast } from "react-toastify";
import {
  EDealRequestType,
  EMarketTypes,
} from "../../../../../../../../interfaces";
import { useNavigate } from "react-router-dom";
import AuthModal from "../../../../../../auth/components/modals/authModal";
import { PATHS } from "../../../../../../../shared/constants";
import useOpenModal from "../../../../../../../ui/modal/hooks/useOpenModal";

interface IDoNotKnowPriceSellStep_6 {
  data: IFillDataWizardSell;
}

const DoNotKnowPriceSellStep_6 = ({ data }: IDoNotKnowPriceSellStep_6) => {
  const { goToStep } = useWizard();

  const navigate = useNavigate();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.swap.step_5);
  };

  const {
    data: dataDealRequest,
    error,
    isMutating,
    trigger,
  } = useDealRequest();

  const { offsetY, open, handleChangeModal } = useOpenModal();

  const handleSendData = async () => {
    if (getAccessToken()) {
      try {
        await trigger({
          type: EDealRequestType.Sale,
          data,
          marketType: EMarketTypes.SECONDARY,
        });
        toast.success("Заявка на продажу создана");
        navigate(`/${PATHS.myDeal}`);
      } catch (error: any) {
        if (error?.message === "Unauthorized") {
          handleChangeModal(true);
        }
        toast.error("Ошибка не удалось отправить заявку");
      }
    } else {
      handleChangeModal(true);
    }
  };

  return (
    <div>
      <BaseStep prevStep={handlePrevStep} text="Отправка заявки:">
        <div>
          <Button
            label="Отправить заявку на покупку"
            onClick={handleSendData}
          />
          <AuthModal
            opened={open}
            onClose={() => handleChangeModal(false)}
            offsetY={offsetY}
          />
        </div>
      </BaseStep>
    </div>
  );
};

export default DoNotKnowPriceSellStep_6;
